export const ACTIVEACC_REQUESTING = 'ACTIVEACC_REQUESTING'
export const ACTIVEACC_SUCCESS = 'ACTIVEACC_SUCCESS'
export const ACTIVEACC_ERROR = 'ACTIVEACC_ERROR'
export const ACTIVEACC_URL = '/api/v1/users/confirm_regist'


// WEBPACK FOOTER //
// ./src/views/Pages/ActiveAcc/constants.js